import Image1 from '../../assets/tesimonial-photo/hellen-testimonial.webp';
import Image2 from '../../assets/tesimonial-photo/robert-testimonial.webp';
import Image3 from '../../assets/tesimonial-photo/susan-testimonial.webp';

export const TestData = [
    {
        id: 1,
        image: Image3,
        title: 'Susan Maende',
        description:
            'A really good job, all aspects of the project were followed step by step and with good results.'
    },
    {
        id: 1,
        image: Image2,
        title: 'Robert Geno',
        description:
            'A really good job, all aspects of the project were followed step by step and with good results.'
    },
    {
        id: 1,
        image: Image1,
        title: 'Hellen Amollo',
        description:
            'A really good job, all aspects of the project were followed step by step and with good results.'
    }
];
